import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';
import { useCompanyStore } from '../../store/companyStore';
import type { ProtectedRouteProps } from '../../types/componentType';
import { ROUTES } from '../../routes/routesConfig';
import Loading from '../loading/Loading';

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = '/login'
}) => {
  const { isAuthenticated, isLoading } = useAuth();
  const selectedVinculo = useCompanyStore((state) => state.selectedVinculo);
  const selectedCompany = useCompanyStore((state) => state.selectedCompany);
  const sessionRole = useCompanyStore((state) => state.sessionRole);
  const location = useLocation();
  const hasSelectedPolicy = Boolean(selectedVinculo || selectedCompany?.policySelection?.numeroApolice);
  const isBackofficeSession = String(sessionRole ?? '').trim().toUpperCase() === 'BACKOFFICE';
  const isCompanyPage = location.pathname === ROUTES.COMPANY;

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-primary">
        <div className="text-center">
          <Loading />
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Enforce CompanyPage as a mandatory step before any protected content route.
  if (!isCompanyPage && !hasSelectedPolicy && !isBackofficeSession) {
    return <Navigate to={ROUTES.COMPANY} state={{ from: location }} replace />;
  }

  // If everything is ok, render the protected content
  return <>{children}</>;
};

export default ProtectedRoute;

